const CencoCreditCardGradientIcon = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 311 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6259_253141)">
      <rect
        width="312"
        height="8"
        transform="matrix(1 0 0 -1 -1 8)"
        fill="#0500C4"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 41 50.666)"
        fill="#0500C4"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -24.3334 50.666)"
        fill="#2912A9"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -33.6666 50.666)"
        fill="#44179A"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -43 50.666)"
        fill="#641E8D"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -53.8885 50.666)"
        fill="#862681"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -65.2965 50.666)"
        fill="#AB2F74"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -76.7035 50.666)"
        fill="#D13768"
      />
      <circle
        cx="51.3333"
        cy="51.3333"
        r="51.3333"
        transform="matrix(1 0 0 -1 -88.1115 50.666)"
        fill="#F9405D"
      />
    </g>
    <defs>
      <clipPath id="clip0_6259_253141">
        <rect
          width="312"
          height="8"
          fill="white"
          transform="matrix(1 0 0 -1 -1 8)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default CencoCreditCardGradientIcon;
